/* eslint-disable react/prop-types */
import React, { Fragment } from 'react'
import Button from 'components/Button'
import ErrorMessage from 'utils/ErrorMessage'
import UploadIcon from 'components/icons/UploadIcon'
import Control from 'components/Control/Control'

import Add from 'components/icons/Add'
import { uploadFile, deleteFile } from 'modules/Drive/actions'
import { useDispatch } from 'react-redux'
import {
  Wrapper,
  StyledUpload,
  Cirlcle,
  SpanText,
  TextWrapper,
  UploadText,
  AddIcon,
  SmallButtons,
  StyledH2,
} from 'components/Uploader/Styles'

const ImageUploader = ({
  isDelete,
  file,
  setFile,
  isDefault = false,
  isImage = false,
  showTextUploder,
  showButtonUploder,
  fileName,
  format,
}) => {
  const dispatch = new useDispatch()

  const getFileUrl = async info => {
    let getType = info?.file?.type?.includes('xlsx') ? 'xlsx' : 'csv'
    let name = fileName + '.' + getType
    let response = await dispatch(uploadFile(info?.file?.originFileObj, name))
    if (response) {
      setFile(response)
    }
  }

  const props = {
    name: 'file',
    multiple: false,
    listType: 'picture',
    accept: '.xlsx',
    beforeUpload: file => {
      const isLt10mb = file.size / 1024 / 1024 < 10
      if (!isLt10mb) {
        ErrorMessage('Image must smaller than 10mb!')
        return false
      } else if (!file?.type.includes('xlsx') && !file?.type.includes('csv')) {
        ErrorMessage('File should be in xlsx/csv  format!')
        return false
      }
    },
    onChange: async info => {
      if (isDelete && info?.file?.status === 'done') {
        let response = await dispatch(deleteFile(file))
        if (response) {
          return getFileUrl(info)
        }
      } else if (!isDelete && info?.file?.status === 'done') {
        return getFileUrl(info)
      }
    },
    itemRender: () => {},
  }

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess('OK')
    }, 0)
  }

  const onBeforeUpload = file => {
    const isLt10mb = file.size / 1024 / 1024 < 10
    if (!isLt10mb) {
      ErrorMessage('File must smaller than 10mb!')
      return false
    } else if (!file?.type.includes('spreadsheetml')) {
      ErrorMessage('File should be in xlsx/csv  format!')
      return false
    }
  }
  const onBeforeUpload1 = file => {
    const isLt10mb = file.size / 1024 / 1024 < 10
    if (!isLt10mb) {
      ErrorMessage('Image must smaller than 10mb!')
      return false
    } else if (!(file?.type.includes('png') || file?.type?.includes('jpeg'))) {
      ErrorMessage('File should be in jpg/jpeg or png format!')
      return false
    }
  }

  // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
  const onChangeFileUpload = async info => {
    if (info?.file?.status === 'done') {
      let getType = info?.file?.type?.includes('spreadsheetml') ? 'xlsx' : 'csv'
      let name = fileName + '.' + getType
      let response = await dispatch(uploadFile(info?.file?.originFileObj, name))
      if (response) {
        let fileObject = {
          name: name,
          url: response,
          size: info?.file?.size,
          date: new Date().getTime(),
          type: getType,
        }
        setFile(fileObject)
      }
    }
  }

  const getFileUrl1 = async info => {
    let getType = info?.file?.type?.includes('png') ? 'png' : 'jpg'
    let name = fileName + '.' + getType
    let response = await dispatch(uploadFile(info?.file?.originFileObj, name))
    if (response) {
      setFile(response)
    }
  }
  const onChangeFileUpload1 = async info => {
    if (info?.file?.status === 'done') {
      let getType = info?.file?.type?.includes('png') ? 'png' : 'jpg'
      let name = fileName + '.' + getType
      let response = await dispatch(uploadFile(info?.file?.originFileObj, name))
      if (response) {
        let fileObject = {
          name: name,
          url: response,
          size: info?.file?.size,
          date: new Date().getTime(),
          type: getType,
        }
        setFile(fileObject)
      }
    }
  }

  const props1 = {
    name: 'file',
    multiple: false,
    listType: 'picture',
    accept: '.jpeg, .jpg , .png',
    beforeUpload: file => {
      const isLt10mb = file.size / 1024 / 1024 < 10
      if (!isLt10mb) {
        ErrorMessage('Image must smaller than 10mb!')
        return false
      } else if (
        !(file?.type.includes('png') || file?.type?.includes('jpeg'))
      ) {
        ErrorMessage('File should be in jpg/jpeg or png format!')
        return false
      }
    },
    onChange: async info => {
      if (isDelete && info?.file?.status === 'done') {
        let response = await dispatch(deleteFile(file))
        if (response) {
          return getFileUrl1(info)
        }
      } else if (!isDelete && info?.file?.status === 'done') {
        return getFileUrl1(info)
      }
    },
    itemRender: () => {},
  }

  return (
    <Fragment>
      {isDefault && (
        <Wrapper>
          <StyledUpload
            {...props}
            type="file"
            accept={'.xlsx'}
            customRequest={dummyRequest}
            onChange={onChangeFileUpload}
            beforeUpload={onBeforeUpload}
            maxCount={1}
            drag
          >
            <SmallButtons
              icon={<UploadIcon />}
            />
         <TextWrapper center alignCenter>
  <StyledH2>Browse or drag & drop .Jpg file</StyledH2>
</TextWrapper>
            <TextWrapper>
              <SpanText>Recommended size </SpanText>
              <Cirlcle />
              <SpanText>600px W x 200px H</SpanText>
            </TextWrapper>
          </StyledUpload>
        </Wrapper>
      )}
      {isImage && (
        <Wrapper>
          <StyledUpload
            {...props1}
            type="file"
            accept={'.jpeg, .jpg ,.png'}
            customRequest={dummyRequest}
            onChange={onChangeFileUpload1}
            beforeUpload={onBeforeUpload1}
            maxCount={1}
            drag
          >
            <SmallButtons
              icon={<UploadIcon />}
            />   <TextWrapper center alignCenter>
            <StyledH2>Browse or drag & drop .Jpg file</StyledH2>
            </TextWrapper>
            <TextWrapper>
              <SpanText>Recommended size </SpanText>
              <Cirlcle />
              <SpanText>600px W x 200px H</SpanText>
            </TextWrapper>
          </StyledUpload>
        </Wrapper>
      )}
      {showTextUploder && (
        <StyledUpload {...props} type="file" customRequest={dummyRequest}>
            <Control center alignCenter top="5px">
              <AddIcon>
                <Add />
              </AddIcon>
              <UploadText>Upload File</UploadText>
            </Control>
        </StyledUpload>
      )}
      {showButtonUploder && (
        <StyledUpload {...props} type="file" customRequest={dummyRequest}>
          <Button.Primary text="Change" height={'32px'} />
        </StyledUpload>
      )}
    </Fragment>
  )
}

export default ImageUploader
